export const clientFormData = (others) => {
  return {
    ...others,

    noEmail: false,

    silentEdit: false,
  }
}
